export default __webpack_public_path__ + "static/media/R4koritu.257d4b43.mp3";